import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'shared-button',
  standalone: false,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {

  @Input() redirectTo: string = '';
  @Input() label: string = '';

  constructor(private router: Router) {}

  handleClick() {
    if (this.redirectTo) {
      this.router.navigate([this.redirectTo]);
    }
  }

}
